import { Feature, FeatureModel } from '@/models/feature.model';
import { storeToRefs } from 'pinia';
import { useFeaturesStore } from '../stores/features';
import { CrudService } from './crud.service';

export class FeaturesService {
  public static readonly priceFeatureEnabled = import.meta.env.VITE_APP_priceFeatureEnabled === 'true';
  public static readonly selectableFieldsEnabled = import.meta.env.VITE_APP_selectableFieldsEnabled === 'true';
  public static readonly enableSelfSellIn = import.meta.env.VITE_APP_enableSelfSellIn === 'true';
  public static readonly orderTemplateDownloadEnabled =
    import.meta.env.VITE_APP_downloadOrderTemplateEnabled === 'true';

  private crudService: CrudService<FeatureModel>;
  private errorMode!: boolean;

  constructor() {
    this.crudService = new CrudService<FeatureModel>('features');
  }

  public async hasFeature(feature: Feature, accountId: string): Promise<boolean> {
    // if fetching of features fails, fetch them again next time, but for now, return false.
    const features = await this.getFeatures(accountId);

    return !this.errorMode && features?.[feature];
  }

  private async getFeatures(accountId: string): Promise<FeatureModel> {
    const { features } = storeToRefs(useFeaturesStore());
    const { addAcountFeatures } = useFeaturesStore();

    if (!features.value[accountId] && accountId) {
      const result = await this.crudService.do('get', `?accountId=${accountId}`);
      if (result.isValid() && result.model) {
        this.errorMode = false;
        addAcountFeatures({ [accountId]: result.model });
      } else {
        this.errorMode = true;
      }
    }

    return features.value[accountId];
  }
}
